<template>
    <div class="wrap">
        <TheHeader />
        <main>
            <div class="content inner">
                <div class="cate row mtb80">
                    <div class="left box">
                        <div class="category">
                            <ul class="main">
                                <li @click="goCategory(1, 0)" :class="{ active: activeType === 1 }">
                                    <p>태양광 모듈<!--span class="material-symbols-outlined">keyboard_arrow_down</span--></p>
                                    <ul class="sub">
                                        <li @click.stop="goCategory(1, 1)">결정질 실리콘 태양광 모듈</li>
                                        <li @click.stop="goCategory(1, 2)">박막 태양광 모듈</li>
                                    </ul>
                                </li>

                                <li @click="goCategory(2, 0)" :class="{ active: activeType === 2 }">
                                <p>단열재<!--span class="material-symbols-outlined">keyboard_arrow_down</span--></p>
                                    <ul class="sub">
                                        <li @click.stop="goCategory(2, 1)">외단열재</li>
                                        <li @click.stop="goCategory(2, 2)">내단열재</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="right box">
                        <div class="detail_wrap">    
                            <div class="row">
                                <div class="img_area">
                                    <img :src="library?.thumb_img ? apiBaseUrl + '/' + library.thumb_img : defaultImg" alt="">
                                </div>
                                <div class="info">
                                    <h2>{{ library?.module_name }}</h2>
                                    <p>
                                      나의 총 포인트 :
                                      <strong class="red_f">
                                        {{ user?.point === 0 ? '-' : user?.point + 'p' }}
                                      </strong>
                                    </p>

                                    <p>
                                      라이브러리 포인트 가격 :
                                      <strong class="red_f">
                                        {{ library?.point ? library.point + 'p' : '-' }}
                                      </strong>
                                    </p>

                                    <span>
                                      구매 후 나의 포인트 잔액 :
                                      <strong class="red_f">
                                        {{ typeof remainPoint === 'number' ? remainPoint + 'p' : remainPoint }}
                                      </strong>
                                    </span>
                                    <div class="btns">
                                        <button class="buttn" type="button"  @click="download">다운로드</button>
                                        <button class="buttn red_bg" type="button" @click="$router.push('/inquire_form?type=2')">포인트 문의</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table view">
                            <table><tbody>
                                <tr>
                                    <th>모델명</th>
                                     <td>{{ library?.module_name }}</td>
                                     <th>두께</th>
                                     <td>{{ library?.thickness }}</td>
                                </tr>
                                <tr>
                                     <th>회사명</th>
                                     <td>{{ library?.company }}</td>
                                     <th>색상</th>
                                     <td>{{ library?.color }}</td>
                                </tr>
                                <tr v-if="activeType === 1 && library">
                                    <th>구조</th>
                                    <td>{{ library?.structure }}</td>
                                    <th>모듈 크기</th>
                                    <td>{{ library?.module_size }}</td>
                                  </tr>
                                  <tr v-if="activeType === 1 && library">
                                    <th>출력</th>
                                    <td>{{ library?.output }}</td>
                                    <th>효율</th>
                                    <td>{{ library?.rate }}</td>
                                  </tr>
                                  <tr v-if="activeType === 1 && library">
                                    <th>무게</th>
                                    <td>{{ library?.weight }}</td>
                                    <th>유형</th>
                                    <td>{{ library?.category }}</td>
                                  </tr>

                                <tr v-if="activeType === 2 && library">
                                    <th>압축강도</th>
                                    <td>{{ library.zip }}</td>
                                    <th>굴곡 파괴하중</th>
                                    <td>{{ library.curve }}</td>
                                  </tr>
                                  <tr v-if="activeType === 2 && library">
                                    <th>밀도</th>
                                    <td>{{ library.density }}</td>
                                    <th>열전도율</th>
                                    <td>{{ library.conductivity }}</td>
                                  </tr>
                                  <tr v-if="activeType === 2 && library">
                                    <th>외/내</th>
                                    <td>{{library.cate == 1  ? '외단열재'  : library.cate == 2  ? '내단열재'  : '-' }}</td>
                                    <th>흡수량</th>
                                    <td>{{ library.absorption }}</td>
                                  </tr>
                            </tbody></table>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <TheFooter />
    </div>
</template>

<script>
    import TheHeader from '@/components/TheHeader.vue'   
    import TheFooter from '@/components/TheFooter.vue'
    import api from '@/api'
    import logoImg from '@/assets/logo.svg'

    export default {
        name: 'BIM_LibraryMarketView',
        components: {   
            TheHeader,
            TheFooter
        },
        data() {
          return {
            activeType: 0,        
            library: null,
            isLoggedIn: false,
            user: null,
            defaultImg: logoImg
          }
        },
        computed: {
          apiBaseUrl() {
            return api.defaults.baseURL || ''
          },

          remainPoint() {
            if (!this.user || !this.library) return '-'

            const userPoint = Number(this.user.point)
            const libraryPoint = Number(this.library.point)

            if (userPoint === 0) return '-'
            if (userPoint < libraryPoint) return '잔액부족'

            return userPoint - libraryPoint
          }
        },
        async mounted() {
        await this.checkAuth();

          if (!this.isLoggedIn) {
              const referer = window.location.pathname + window.location.search;
              window.location.href =
                `/login_form?referer=${encodeURIComponent(referer)}`;
              return;
          }

            const q = this.$route.query;

            this.activeType = q.type ? Number(q.type) : 0;

            if (q.id) {
                await this.fetchLibrary(q.id);
            }
        },
        methods: {
      async checkAuth() {
          try {
            const res = await api.get('/admin/auth_check', { withCredentials: true });
            if (res.data.logged_in) {
              this.isLoggedIn = true;
              this.user = res.data.user;
            } else {
              this.isLoggedIn = false;
              this.user = null;
            }
          } catch (e) {
            this.isLoggedIn = false;
          }
       },
          async fetchLibrary(id) {
              try {
                  const res = await api.get('/admin/library_view', {
                      params: { id }
                   });

                  if (res.data.success) {
                      this.library = res.data.data;
                  }
              } catch (e) {
                  alert('라이브러리 정보를 불러오지 못했습니다.');
              }
            },
          async download() {
            if (!this.isLoggedIn) {
              alert('로그인이 필요한 서비스입니다.')
              return
            }

            if (!this.library || !this.library.id) {
              alert('id가 없습니다.')
              return
            }

            // 파일 경로 자체가 없는 경우
            if (!this.library.module_img && !this.library.insulation_img) {
              alert('파일이 없습니다.')
              return
            }

            try {
              const res = await api.post(
                '/admin/library_download',
                { library_id: this.library.id },
                { withCredentials: true }
              )

              if (res.data.success && res.data.download_url) {
                window.location.href =
                  (api.defaults.baseURL || '') + '/' + res.data.download_url
              } else {
                alert('오류 발생')
              }
            } catch (e) {
              alert('다운로드 중 오류가 발생했습니다.')
            }
          },
          goCategory(type, cate) {
            this.$router.push({
             path: '/bim_library_market',
             query: { type, cate }
            });
          }
        }
    }
</script>